window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    $('.countdown-modal__close-btn').on('click', function () {
      $('.countdown-modal__outer-wrapper').toggleClass(
        'countdown-modal__hidden',
        true,
      );
    });

    let countdownWrappers = $('.countdown-banner__wrapper');

    countdownWrappers.each(function () {
      let countdownWrapper = $(this);
      let countdown = countdownWrapper.find('.countdown-banner__timer');
      let countdownDate = countdown.data('date');
      let countdownTime = countdown.data('time');
      let countdownTimezone = countdown.data('timezone');

      let countdownDatetime = new Date(
        `${countdownDate}T${countdownTime}${countdownTimezone}`,
      );

      if (countdownDatetime == 'Invalid Date') {
        // console.error("Invalid date format");
        $('.countdown-banner__wrapper').toggleClass(
          'countdown-banner__wrapper--hidden',
          true,
        );
        return;
      }

      let countdownInterval = setInterval(function () {
        let now = new Date().getTime();
        let distance = countdownDatetime - now;

        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const showSeconds = days < 1;

        $('.countdown-banner__timer .seconds')
          .closest('.unit-wrapper')
          .toggleClass('countdown-banner__timer--unit-hidden', !showSeconds);

        countdown.find('.days').text(days);
        countdown.find('.hours').text(hours);
        countdown.find('.minutes').text(minutes);

        if (showSeconds) countdown.find('.seconds').text(seconds);

        countdownWrapper.toggleClass(
          'countdown-banner__wrapper--hidden',
          distance < 0,
        );

        if (distance < 0) {
          clearInterval(countdownInterval);
        }
      }, 1000);
    });

    $('.countdown-banner__wrapper').on('click', function (e) {
      e.preventDefault();
      $('.countdown-modal__outer-wrapper').toggleClass(
        'countdown-modal__hidden',
        false,
      );
    });
  });
});
